import { Options } from '@angular-slider/ngx-slider';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PaymentInfoService } from 'src/app/services/payment-info.service';
import { SmilePointsService } from 'src/app/services/smile-points.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-smile-points',
  templateUrl: './smile-points.component.html',
  styleUrls: ['./smile-points.component.scss'],
})
export class SmilePointsComponent implements OnInit {
  @Input() payNowValue: any;
  payWithVat: any;
  @Input() transactionCategory: any;
  isPrimary: boolean;
  avilableSmilesPoints: number;
  slider: any;
  max: any=0;
  balanceToBePaidByCard: number;
  requiredSmilesPoints: any;
  currentPoints: any;
  moneyAmountToBePaidByPoints: number;
  smilesPointsLeft: number;
  loyaltyMultiplier: any;
  min: any;
  options: Options
   = {
    floor: 0,
    ceil: 0,
    hideLimitLabels:  true,
    // translate: (value: number = 0): string => {
    //   return (
    //     value + '<small class="fs-14 eand-letterspace-2"> '+this.translate.instant('points')+'</small>'
    //         );
    // },
  };

  paymentRanges = [];
  @Output() smileAmountInfo = new EventEmitter<any>();
  @Output() onPayAllWithSmiles = new EventEmitter<any>();
  @Output() onZeroSmilesPoints = new EventEmitter<any>();
  balanceToBePaidByPoints: any;
  currentLanguage = 'en';
  SmilesPointsRatio: any;
  constructor(
    private PIS: PaymentInfoService,
    private UIS: UserInfoService,
    private SPS: SmilePointsService,
    private UTS: UtilitiesService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    // this.options = {
    //   floor: 0,
    //   hideLimitLabels:  true,
    //   ceil: this.max,
    //   translate: (value: number = this.max): string => {
    //     return (
    //       value + '<small class="fs-14 eand-letterspace-2"> '+this.translate.instant('points')+'</small>'
    //     );
    //   },
    // };
    this.currentLanguage = this.UTS.getLocaleLanguage();
    this.slider = { value: this.max? this.max : 0 };
  }
  ngAfterViewInit() {
    this.payNowValue = Number(this.payNowValue);
    this.rangeChanges(null);
  }

  rangeChanges(e) {
   

    if (e && e.value != null) {
      const value = e.value;
      this.PIS.getSmilePointEquivalency(this.transactionCategory).subscribe(
        (response: any) => {
          if (response.success) {
            this.paymentRanges = response.paymentRanges;
            response.paymentRanges.forEach((item) => {
              if (
                item.pointStartRange <= value &&
                item.pointEndRange >= value
              ) {
                const payment = this.payNowValue - +(this.convertPointsToAED( value, this.transactionCategory, this.payNowValue)?.toFixed(2));
                this.balanceToBePaidByCard = payment && payment > 0 ? Number(payment?.toFixed(2)) : 0;

                this.smilesPointsLeft =
                  this.avilableSmilesPoints - this.slider.value < 0
                    ? 0
                    : this.avilableSmilesPoints - this.slider.value;
                this.smileAmountInfo.emit({
                  moneyAmount: this.balanceToBePaidByCard,
                  pointsAmount: value,
                  moneyAmountToBePaidByPoints: this.convertPointsToAED(
                    value,
                    this.transactionCategory,
                    this.payNowValue
                  ).toFixed(2),
                  loyaltyMultiplier: this.loyaltyMultiplier
                });
              }
            });
          }
        },
        (error) => {}
      );
    } else {
      this.getSmilePoints();
    }
  }

  getSmilePoints() {
    this.payNowValue = Number(this.payNowValue);

    this.payWithVat = this.payNowValue; // money from backendService
    ///get ratio
    this.PIS.getSmilePointEquivalency(this.transactionCategory).subscribe(
      (response: any) => {
        if (response.success) {
          this.paymentRanges = response.paymentRanges;
          response.paymentRanges.forEach((item) => {
            if (
              item.aedStartRange <= this.payNowValue &&
              item.aedEndRange >= this.payNowValue
            ) {
              this.SmilesPointsRatio = item.factor;
            }
          });
        }
      },
      (error) => {}
    );
    // get ratio
    this.UIS.getUserInfo().subscribe(
      (getLoggedInUserResult: any) => {
        //$rootScope.showLoader =true;
        this.PIS.getUserAccounts().subscribe(
          (response: any) => {
            if (response.userAccounts && response.userAccounts.length > 0) {
              //if user is logged in with secondary individual login then only 1 account will be retreived
              //if user is logged in with primary individual login or normal login then multiple account will be retreived
              if (response.userAccounts.length == 1) {
                this.PIS.getAccountSummary(
                  response.userAccounts[0].accountId
                ).subscribe(
                  (response2: any) => {
                    this.buildSmilesPointsSlider(
                      response2.userAccount.actualTotalPoints
                    );
                    // this.cdr.detectChanges();
                    this.isPrimary = true;
                  },
                  (error) => {}
                );
              } else {
                let isPrimary = false;
                let primaryAccountIndex = -1;
                let accountId = 0;
                for (var i = 0; i < response.userAccounts.length; i++) {
                  if (response.userAccounts[i].primary) {
                    primaryAccountIndex = i;
                    accountId = response.userAccounts[i].accountId;
                    break;
                  }
                }
                if (primaryAccountIndex != -1) {
                  this.PIS.getAccountSummary(accountId).subscribe(
                    (response: any) => {
                      this.buildSmilesPointsSlider(
                        response.userAccount.actualTotalPoints
                      );
                      // this.cdr.detectChanges();
                      isPrimary = true;
                    },
                    (error) => {}
                  );
                } else {
                  this.avilableSmilesPoints = 0;
                  this.onZeroSmilesPoints.emit({ isZeroSmilesPoints: true });
                }
              }
            } else {
              this.avilableSmilesPoints = 0;
            }
          },
          (error) => {}
        );
      },
      (error) => {}
    );
  }

  buildSliderWhenChangeSmilesPointsBalance(newSliderValue) {
    if (!newSliderValue || isNaN(newSliderValue) || newSliderValue < 0) {
      this.slider.value = 0;
    } else if (newSliderValue >= this.max) {
      this.slider.value = this.max;
      this.balanceToBePaidByCard = 0;
    } else {
      this.slider.value = newSliderValue;
    }
    this.paymentRanges.forEach((item) => {
      if (
        item.pointStartRange <= this.slider.value &&
        item.pointEndRange >= this.slider.value
      ) {
        	this.SmilesPointsRatio = item.factor;
      }
    });

    if ((this.requiredSmilesPoints - this.slider.value) < 0)
      this.balanceToBePaidByCard = 0;
    else {
      if (
        Number(
          this.payNowValue -
            this.convertPointsToAED(
              this.slider.value,
              this.transactionCategory,
              this.payNowValue
            )
        ) < 0
      ) {
        this.balanceToBePaidByCard = 0;
      } else {
        this.balanceToBePaidByCard = Number(
          Number(
            this.payNowValue -
              (Number(
                this.convertPointsToAED(
                  this.slider.value,
                  this.transactionCategory,
                  this.payNowValue
                ).toFixed(2)
              ))
          ).toFixed(2)
        );
      }
    }

    this.applyChangesOnRestOfFields();
  }
  convertPointsToAED(points, type, valueToBePaidInAED) {
    var dataObj = this.SPS.convertPointsToAED(points, type, valueToBePaidInAED)
    this.loyaltyMultiplier = dataObj.loyaltyMultiplier;
    return Number(dataObj.returnedValue);
  }

  convertAEDToPoints(aed, type) {
    return this.SPS.convertAEDToPoints(aed, type);
  }

  buildSliderWhenChangeCardBalance() {
    if (
      !this.balanceToBePaidByCard ||
      isNaN(this.balanceToBePaidByCard) ||
      this.balanceToBePaidByCard < 0
    ) {
      this.balanceToBePaidByCard = 0;
      this.slider.value = this.max;
    } else if (this.balanceToBePaidByCard == 0) {
      this.slider.value = this.max;
      //				this.balanceToBePaidByCard= (this.requiredSmilesPoints - this.slider.value)<0?0:(this.requiredSmilesPoints - this.slider.value)/$rootScope.SmilesPointsRatio ;
      this.balanceToBePaidByCard = this.convertPointsToAED(
        (this.requiredSmilesPoints - this.slider.value) < 0
          ? 0
          : this.requiredSmilesPoints - this.slider.value,
        this.transactionCategory,
        this.payNowValue
      );

      //			}else if(this.balanceToBePaidByCard>=(Math.round((this.max / $rootScope.SmilesPointsRatio) * 100) / 100)){
    } else if (
      this.balanceToBePaidByCard >=
      Math.round(
        this.convertPointsToAED(
          this.max,
          this.transactionCategory,
          this.payNowValue
        )
      )
    ) {
      //				this.balanceToBePaidByCard=Math.round((this.max / $rootScope.SmilesPointsRatio) * 100) / 100;
      this.balanceToBePaidByCard = Math.round(
        this.convertPointsToAED(
          this.max,
          this.transactionCategory,
          this.payNowValue
        )
      );
      this.slider.value = 0;
    } else {
      //				this.slider.value=this.requiredSmilesPoints-(this.balanceToBePaidByCard*$rootScope.SmilesPointsRatio);
      this.slider.value =
        this.requiredSmilesPoints -
        this.convertAEDToPoints(
          this.balanceToBePaidByCard,
          this.transactionCategory
        );
    }

    this.applyChangesOnRestOfFields();
  }

  applyChangesOnRestOfFields() {
    this.currentPoints = this.slider.value;

    this.moneyAmountToBePaidByPoints = Number(
      this.convertPointsToAED(
        this.currentPoints,
        this.transactionCategory,
        this.payNowValue
      ).toFixed(2)
    );
    this.smilesPointsLeft =
      (this.avilableSmilesPoints - this.slider.value) < 0
        ? 0
        : this.avilableSmilesPoints - this.slider.value;
    if (this.balanceToBePaidByCard == 0) {
      this.onPayAllWithSmiles.emit({ isPayAllWithSmiles: true });
    } else {
      this.onPayAllWithSmiles.emit({ isPayAllWithSmiles: false });
    }
    this.smileAmountInfo.emit({
      moneyAmount: this.balanceToBePaidByCard,
      pointsAmount: this.currentPoints,
      moneyAmountToBePaidByPoints: this.moneyAmountToBePaidByPoints,
      loyaltyMultiplier: this.loyaltyMultiplier
    });
  }

  buildSmilesPointsSlider(actualTotalPoints) {
    this.avilableSmilesPoints = actualTotalPoints;
    if (this.avilableSmilesPoints == 0) {
      this.onZeroSmilesPoints.emit({ isZeroSmilesPoints: true });
    } else {
      this.onZeroSmilesPoints.emit({ isZeroSmilesPoints: false });
    }

    //			this.requiredSmilesPoints = Math.round(this.payWithVat*$rootScope.SmilesPointsRatio* 100) / 100;
    this.requiredSmilesPoints = Math.round(
      this.convertAEDToPoints(this.payWithVat, this.transactionCategory)
    );
    this.smilesPointsLeft = this.avilableSmilesPoints;
    // this.cdr.detectChanges();
    this.balanceToBePaidByPoints = this.requiredSmilesPoints;

    //this.balanceToBePaidByCard = this.balanceToBePaidByPoints/$rootScope.SmilesPointsRatio ;
    this.balanceToBePaidByCard = 0;
    if (this.avilableSmilesPoints && this.avilableSmilesPoints > 0) {
      this.onPayAllWithSmiles.emit({ isPayAllWithSmiles: true });
    }

    this.moneyAmountToBePaidByPoints = 0;
    this.min = 0;
    if (this.avilableSmilesPoints > this.requiredSmilesPoints) {
      // this.max = this.requiredSmilesPoints;
      this.options = {
        floor: 0,
        hideLimitLabels:  true,
        ceil: this.requiredSmilesPoints,
        translate: (value: number = 0): string => {
          return (
            value + '<small class="fs-14 eand-letterspace-2"> '+this.translate.instant('points')+'</small>'
          );
        },
      };
      this.balanceToBePaidByCard = 0;
      // this.cdr.detectChanges();
    } else {
      this.max = this.avilableSmilesPoints;
      this.cdr.detectChanges();
       this.options = {
        floor: 0,
        hideLimitLabels:  true,
        ceil: this.max,
        translate: (value: number = 0): string => {
          // if(this.max != 0)
          return (
            value + '<small class="fs-14 eand-letterspace-2"> '+this.translate.instant('points')+'</small>'
          );
        },
      };
      //				   this.balanceToBePaidByCard= (this.requiredSmilesPoints - this.avilableSmilesPoints)<0?0:(this.requiredSmilesPoints - this.avilableSmilesPoints)/$rootScope.SmilesPointsRatio ;
      if ((this.requiredSmilesPoints - this.avilableSmilesPoints) < 0) {
        this.balanceToBePaidByCard = 0;
        // this.cdr.detectChanges();
      } else {
        if (
          Number(
            this.convertPointsToAED(
              this.requiredSmilesPoints - this.avilableSmilesPoints,
              this.transactionCategory,
              this.payNowValue
            )
          ) < 0
        ) {
          this.balanceToBePaidByCard = 0;
          // this.cdr.detectChanges();
        } else {
          this.balanceToBePaidByCard = Number(
            Number(
              this.convertPointsToAED(
                this.requiredSmilesPoints,
                this.transactionCategory,
                this.payNowValue
              ) -
                this.convertPointsToAED(
                  this.avilableSmilesPoints,
                  this.transactionCategory,
                  this.payNowValue
                )
            ).toFixed(2)
          );
          // this.cdr.detectChanges();
        }
      
      }
    }
  // this.smileAmountInfo({
        //   moneyAmount : this.balanceToBePaidByCard,
        //   pointsAmount :this.max,
        //   moneyAmountToBePaidByPoints :  (this.convertPointsToAED(this.max,this.transactionCategory, this.payNowValue)).toFixed(2)
        // });
       
    this.slider = {
      value: this.max,
      options: {
        floor: this.min,
        ceil: this.max,
        step: 1,
        disabled: this.avilableSmilesPoints == 0,
        showSelectionBar: true,
        onChange: function () {
          this.smilesPointsLeft =
            (this.avilableSmilesPoints - this.slider.value) < 0
              ? 0
              : this.avilableSmilesPoints - this.slider.value;

          this.currentPoints = this.slider.value;

          //							    this.balanceToBePaidByCard= (this.requiredSmilesPoints - this.slider.value)<0?0:(this.requiredSmilesPoints - this.slider.value)/$rootScope.SmilesPointsRatio ;
          this.paymentRanges.forEach((item) => {
            if (
              item.pointStartRange <= this.slider.value &&
              item.pointEndRange >= this.slider.value
            ) {
              		this.SmilesPointsRatio = item.factor;
            }
          });

          if ((this.requiredSmilesPoints - this.slider.value) < 0)
            this.balanceToBePaidByCard = 0;
          else {
            if (
              (Number(
                this.payNowValue -
                  this.convertPointsToAED(
                    this.slider.value,
                    this.transactionCategory,
                    this.payNowValue 
                  )) < 0
              )
            ) {
              this.balanceToBePaidByCard = 0;
            } else {
              this.balanceToBePaidByCard = (
                this.payNowValue -
                this.convertPointsToAED(
                  this.slider.value,
                  this.transactionCategory,
                  this.payNowValue
                ).toFixed(2)
              ).toFixed(2);
            }
          }
          //					    	 	 this.balanceToBePaidByCard= (this.requiredSmilesPoints - this.slider.value)<0?0: (this.payNowValue - ((this.slider.value * $rootScope.SmilesPointsRatio).toFixed(2))).toFixed(2);

          //							    this.moneyAmountToBePaidByPoints = Math.round((this.currentPoints / $rootScope.SmilesPointsRatio) * 100) / 100;
          this.moneyAmountToBePaidByPoints = this.convertPointsToAED(
            this.currentPoints,
            this.transactionCategory,
            this.payNowValue
          ).toFixed(2);

          if (this.balanceToBePaidByCard == 0) {
            this.onPayAllWithSmiles({ isPayAllWithSmiles: true });
          } else {
            this.onPayAllWithSmiles({ isPayAllWithSmiles: false });
          }

          // this.smileAmountInfo.emit({
          //   moneyAmount: this.balanceToBePaidByCard,
          //   pointsAmount: this.currentPoints,
          //   moneyAmountToBePaidByPoints: this.moneyAmountToBePaidByPoints,
          //    loyaltyMultiplier: this.loyaltyMultiplier
          // });
        },
      },
    };
    this.cdr.detectChanges();
    if (this.slider) {
      this.smilesPointsLeft =
        (Number(this.avilableSmilesPoints) - Number(this.requiredSmilesPoints)) <
        0
          ? 0
          : Number(this.avilableSmilesPoints) -
            Number(this.requiredSmilesPoints);
      // this.cdr.detectChanges();
    }
  
    // if(this.slider){
    //   this.smilesPointsLeft = (this.avilableSmilesPoints - this.slider.value)<0?0:(this.avilableSmilesPoints - this.slider.value);
    // }
    setTimeout(() => {
      this.rangeChanges(this.slider);
      // this.smileAmountInfo.emit({
      //   moneyAmount: this.balanceToBePaidByCard,
      //   pointsAmount: this.slider.value,
      //   moneyAmountToBePaidByPoints: this.convertPointsToAED(
      //     this.slider.value,
      //     this.transactionCategory,
      //     this.payNowValue
      //   ).toFixed(2),
      //    loyaltyMultiplier: this.loyaltyMultiplier
      // });
    }, 500);
  }
}
